import { CanvasCard, clx, H2 } from "@hm/fundamental"
import { ReactNode } from "react"

import { SectionContent } from "./section-content"

interface CarvasInfoBoxProps {
	"data-cy"?: string
	className?: string
	sections: {
		id: string
		title?: string | ReactNode
		content: string | string[] | ReactNode
		className?: string
	}[]
}

export const CarvasInfoBox = ({
	"data-cy": dataCy,
	className,
	sections,
}: CarvasInfoBoxProps) => (
	<CanvasCard
		className={clx("flex flex-col gap-y-12 flex-1", className)}
		data-cy={dataCy}
	>
		{sections.map((section, index) => (
			<section
				data-cy={`${dataCy}-section-${index}`}
				key={section.id}
				className={clx("flex flex-col gap-y-6", section.className)}
			>
				{section.title && (
					<H2 className="text-foreground">{section.title}</H2>
				)}

				<SectionContent content={section.content} />
			</section>
		))}
	</CanvasCard>
)
